import {useAppEnvStore} from "stores/appEnvStore";
import AxiosService from "src/services/axiosService";
import appNotificationService from "src/services/utils/appNotificationService";
import authHeader from "src/services/authHeader";

class AppEnvService {

  getStoreInstance() {
    if (!this.store) {
      this.store = useAppEnvStore()
    }
    return this.store
  }

  /**
   * Load env variables
   */
  async list() {

    try {
      let response = await AxiosService.get("/appEnv/list", {headers : authHeader()})
      this.getStoreInstance().load(response.data.env)
    }catch(error) {
      appNotificationService.pushError(error);

    }
  }

  getEnv(name) {
    return this.getStoreInstance().getEnv(name)
  }
}

export default new AppEnvService()

